import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import ProChioseTree from "@/components/pro-common/pro-chiose-modal/pro-chiose-tree.vue";
export default {
  name: "pro-chiose-tab-position",
  components: {
    ProChioseTree
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    treeData: {
      type: Array,
      default() {
        return [];
      }
    },
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    _treeData() {
      return JSON.parse(JSON.stringify(this.treeData));
    }
  },
  methods: {
    onChange(item) {
      let checkedList = [...this.value];
      if (item.isCheck) {
        checkedList.unshift(item);
      } else {
        checkedList = checkedList.filter(v => v.tagId !== item.tagId);
      }
      this.$emit("input", checkedList);
    }
  }
};